<template>
    <li class="appe" v-click-outside="outside">
        <div class="panel panel-default b-show" id="notif-bell">
            <div class="panel-body">
                <div class="btn-group a-top-head-dropdown">
                    <div type="button" class="top-actionButtons se5-320 bg-white" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="ControlBox()">
                        <!--<svg class="text-white cil-bell" width="20px" height="20px" viewBox="0 0 16 16" fill="#999a9b" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2z" />
        <path fill-rule="evenodd" d="M8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
    </svg>
    <font class="badge badge-light notif-01 badgeSta">{{str_countUnread}}</font>-->


                        <img src="../../assets/icons/notification.svg" width="23" />
                        <font class="badge badge-light notif-01 badgeSta" v-if="str_countUnread">{{str_countUnread}}</font>
                    </div>

                    <ul class="dropdown-menu dropdown-menu-left a-drop-text p-0" id="myNotif2" :style="setStyle()">
                        <li class='notif-hd-title'>
                            <div class="float-left">
                                <strong> {{ this.getLanguage["HEA"]["N"] }}</strong>
                            </div>

                            <div class="float-right pointer" v-if="str_countUnread">
                                <small @click="ReadAll()"><u><strong>{{ this.getLanguage["HEA"]["NRA"] }}</strong></u></small>
                            </div>
                        </li>

                        <li :class="data.IR ? 'notifRead': 'notifUnread'" v-for="(data,index) in arry_cl" v-bind:key="index">
                            <a href='#' data-toggle='modal' data-target='#onenotifModal' @click='getDetail(data.I)' class='a-top-text-block'>
                                <div class='a-top-text-heading afb-textlimit'>
                                    <strong class="notif-single-title">{{data.T}}</strong>
                                </div>
                                <div class='a-top-text-light'>{{ data.CBD }}</div>
                                <small class="text-muted notif-content">{{ FormatNotifTime(data.CTS, data.CDT) }}</small>
                            </a>
                        </li>

                        <li class="text-center">
                            <a href='#' @click='notiViewMore()' class='button button-regular button-amber one' id='saveprofilebtn'>
                                {{this.getLanguage["HEA"]["VM"]}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'

    export default {
        mixins: [genericHelper],
        computed: {
            ...mapGetters('Language', ['getLanguage']),
        },
        data() {
            return {
                arry_cl: [],
                int_ALLcountUnread: 0,
                int_BOXcountUnread: 0,
                str_countUnread: "",
                bool_showNotif: false,
                obj_notif: [],
                bool_Show: false,
                bool_checkSwitch: false,
                AutoUpdateTO: null,
            }
        },
        methods: {
            ControlBox() { //SV = Sort Value
                this.bool_Show = !this.bool_Show;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
            },
            outside() { //SV = Sort Value
                if (this.bool_Show == true) {
                    this.bool_Show = false;
                }
            },
            setStyle() {
                return `display:${this.bool_Show ? 'block' : 'none'}`;//here change the sort logo
            },
            getNotifList() {
                var that = this;
                that.int_BOXcountUnread = 0;
                that.int_ALLcountUnread = 0;

                //Only the main tab will get pending transaction from db
                if (sessionStorage.getItem('tabId') === localStorage.getItem('tabId')) {
                    this.getDataApi(`/api/anotif/la`,
                        function (d, s) {
                            if (s) {
                                that.arry_cl = d.D.Items;                                
                                localStorage.setItem('notifLA', JSON.stringify(that.arry_cl));
                                for (var i = 0; i < that.arry_cl.length; i++) {
                                    if (!that.arry_cl[i].IR) {
                                        that.int_BOXcountUnread += 1;
                                    }
                                }
                            }
                        });
                }
                else {
                    //Other tabs will get the pending transactions from localstorage stored by main tab                  
                    that.arry_cl = JSON.parse(localStorage.getItem('notifLA'));

                    for (var i = 0; i < that.arry_cl.length; i++) {
                        if (!that.arry_cl[i].IR) {
                            that.int_BOXcountUnread += 1;
                        }
                    }
                }
            },
            getNotifCountNumber() {
                var that = this;

                //Only the main tab will get pending transaction from db
                if (sessionStorage.getItem('tabId') === localStorage.getItem('tabId')) {
                    this.getDataApi(`/api/anotif/c`,
                        function (d, s) {
                            if (s) {
                                that.int_ALLcountUnread = d;
                                localStorage.setItem('notifC', that.int_ALLcountUnread);
                                if (that.int_ALLcountUnread > 9) {
                                    that.str_countUnread = "9+"
                                } else {
                                    that.str_countUnread = that.int_ALLcountUnread.toString();
                                }
                            }
                        });
                }
                else {
                    //Other tabs will get the pending transactions from localstorage stored by main tab                  
                    var TNC = parseInt(localStorage.getItem('notifC'));
                    if (TNC > 9) {
                        that.str_countUnread = "9+"
                    } else {
                        that.str_countUnread = TNC.toString();
                    }
                }

            },
            FormatNotifTime(notifDateTime, currentTime) {

                let startDate = new Date(notifDateTime);
                let endDate = new Date(currentTime);

                let years = endDate.getFullYear() - startDate.getFullYear();
                let months = endDate.getMonth() - startDate.getMonth();
                let days = endDate.getDate() - startDate.getDate();

                if (months < 0) {
                    years--;
                    months += 12;
                }
                if (days < 0) {
                    months--;
                    let lastDayOfMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
                    days += lastDayOfMonth;
                }

                let hours = endDate.getHours() - startDate.getHours();
                if (hours < 0) {
                    days--;
                    hours += 24;
                }
                let minutes = endDate.getMinutes() - startDate.getMinutes();
                if (minutes < 0) {
                    hours--;
                    minutes += 60;
                }
                let seconds = endDate.getSeconds() - startDate.getSeconds();
                if (seconds < 0) {
                    minutes--;
                    seconds += 60;
                }

                let t = {};
                if (years > 0) t['DYR'] = years;
                if (months > 0) t['DMTH'] = months;
                if (days > 0) t['DDAY'] = days;
                if (hours > 0) t['DHR'] = hours;
                if (minutes > 0) t['DMT'] = minutes;
                if (seconds > 0) t['DSC'] = seconds;

                var dateKey = Object.keys(t);
                var temp = ""
                for (var i = 0; i < dateKey.length; i++) {
                    temp += t[dateKey[i]] + " ";
                    temp += this.getLanguage['MEM'][dateKey[i]] + " ";
                }
                return temp;
            },
            getDetail(id) {
                this.$parent.$parent.$parent.$parent.getDetail(id);
            },
            AutoUpdate() {
                this.nextUpdate();
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                this.getNotifList();
                this.getNotifCountNumber();
            },
            ReadAll() {
                this.arry_cl.forEach((value, key) => {
                    if (!value.IR) {
                        var that = this;
                        this.getDataApi(`/api/anotif/ga/${value.I}`,
                            function (d, s) {
                                if (s) {
                                    that.getNotifList();
                                }
                            });
                    }
                });
            },
            notiViewMore() {
                this.bool_Show = false;
                this.$router.push("/Notifications");
            }
        },
        directives: {
            'click-outside': {
                bind: function (el, binding, vNode) {
                    // Provided expression must evaluate to a function.
                    if (typeof binding.value !== 'function') {
                        const compName = vNode.context.name
                        let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                        if (compName) { warn += `Found in component '${compName}'` }

                        console.warn(warn)
                    }
                    // Define Handler and cache it on the element
                    const bubble = binding.modifiers.bubble
                    const handler = (e) => {
                        if (bubble || (!el.contains(e.target) && el !== e.target)) {
                            binding.value(e)
                        }
                    }
                    el.__vueClickOutside__ = handler

                    // add Event Listeners
                    document.addEventListener('click', handler)
                },

                unbind: function (el, binding) {
                    // Remove Event Listeners
                    document.removeEventListener('click', el.__vueClickOutside__)
                    el.__vueClickOutside__ = null

                }
            }
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            next();
        },
        created() {
            this.getNotifList();
            this.getNotifCountNumber();
            this.AutoUpdate();
        },

    }
</script>

<style scoped>
        .c-icon {
            margin-right: 0.3rem;
        }

        #dot {
            height: 0.75em;
            width: 0.75em;
            background-color: yellow;
            border-radius: 50%;
            margin-left: 0.3rem;
        }

        .notif-hd-title {
            background-color: #fff;
            padding: 10px 15px !important;
            border-radius: 2px 2px 0 0;
            margin-left: -0.01em;
            margin-top: -0.01em;
            display: inline-block;
        }

        .notifUnread::after {
            width: 4px;
            background: #f05a1a;
            left: 0;
            top: 0;
            bottom: 0;
            position: absolute;
        }

        .notifUnread {
            background-color: #f6f5fd;
            border-color: #000000;
            /*border-right: 4px solid #ff0000;*/
        }

        .notifUnread > .a-top-text-block:before {
            content: '';
            width: 5px;
            background: rgb(120, 0, 182);
            right: 0;
            top: 0;
            bottom: 0;
            position: absolute;
            height: 5px;
            border-radius: 50%;
        }


        .dropdown-menu {
            border: none;
            box-shadow: 0px 8px 16px 0px #625f5fa6;
            padding-top: 0;
        }

        .a-top-text-heading {
            font-size: var(--text-sm);
            color: var(--gray-dark);
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .a-top-text-light {
            font-size: var(--text-xs);
        }

        .a-top-text-block {
            display: block;
            padding: 3px 20px;
            clear: both;
            font-weight: 400;
            line-height: 1.42857143;
            color: #333;
            white-space: inherit !important;
            /*border-bottom: 1px solid #f4f4f4;*/
            position: relative;
        }

            /*.a-top-text-block:before {
        content: '';
        width: 5px;
        background: rgb(120, 0, 182);
        right: 0;
        top: 0;
        bottom: 0;
        position: absolute;
        height: 5px;
        border-radius: 50%;
    }*/

        .a-top-text-block.unread {
            background: #ffc;
        }

        .a-top-text-block .a-top-text-light {
            color: #999;
            font-size: 0.8em;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .a-top-head-dropdown .a-dropdown-menu {
            width: 350px;
            height: 300px;
            overflow: auto;
        }

        .a-top-head-dropdown li:last-child .a-top-text-block {
            border-bottom: 0;
        }

        .a-topbar-align-center {
            text-align: center;
        }

        .a-top-head-dropdown ul li {
            width: 350px;
            padding: 5px;
            border-bottom: solid 1px #ced2d8;
        }

        .a-top-head-dropdown ul li:nth-child(2) {
            margin-top:-5px;
        }

        ul.a-drop-text li a {
            padding: 5px 10px;
        }

        .a-loader-topbar {
            margin: 5px auto;
            border: 3px solid #ddd;
            border-radius: 50%;
            border-top: 3px solid #666;
            width: 22px;
            height: 22px;
            -webkit-animation: spin-topbar 1s linear infinite;
            animation: spin-topbar 1s linear infinite;
        }

        .button.button-regular.one {
            width: 100%;
            color: var(--cd-color-1);
            text-transform: none;
            font-weight: 400;
            letter-spacing: 0.5px;
            padding-top: 0 !important;
            background-color: #98acbd00;
            border: none;
            font-size: .7em !important;
        }

        .button.button-regular {
            padding: 5px 10px;
            font-size: 11px;
            line-height: 24px;
            margin: 0;
            color: white;
            margin-right: 10px;
            white-space: initial;
            overflow: hidden;
        }

        .dropdown-menu {
            left: -310px !important;
        }

        .dropdown-single-content a {
            border-bottom: 1px solid #e7e7e7;
        }

        .badge-light {
            color: #ffffff;
            background-color: #f0ab4a;
            border-radius: 80px;
            width: 15px;
            height: 15px;
            padding: 3px;
            font-size: 9px;
            position: absolute;
            top: -0.8px;
            right: 0px;
        }

    .notif-single-title {
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 12px;
    }

    .notif-content {
        font-size: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/HeaderDropdown/HeaderDropdownNot.vue